var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.reset)?_c('view-edition-tier',_vm._g(_vm._b({},'view-edition-tier',_vm.attrs,false),_vm.listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }